<script>
  export let active_rule_sheets_list;
</script>

<div class="tourPage_desc">
  {#if active_rule_sheets_list.length == 0}
    <p>loading....</p>
  {:else}
    {#each active_rule_sheets_list as active_rule}
      <h6>{active_rule.active_title}</h6>
      <ul>
        {#each active_rule.rule as rules}
          <li>{@html rules}</li>
        {/each}
      </ul>
    {/each}
  {/if}
</div>
